import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { LoginNav } from './LoginNav';

export function NavBar() {
  return (
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand href="#home">Warehouse Inventory</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/inventory">Inventory</Nav.Link>
            <Nav.Link href="/warehouse">Warehouse</Nav.Link>
            <Nav.Link href="/features">Features</Nav.Link>
            <LoginNav/>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}